import React, { useState } from 'react'

import { PlusOutlined, TeamOutlined, MailOutlined } from '@ant-design/icons'
import { Button, Tabs } from 'antd'
import { useTranslation } from 'react-i18next'

import useCan from '@shared/permissions/useCan';
import ListPageHeader from '@shared/ListPageHeader'
import CreateOperatorInvitationModal from '@shared/operator_invitations/CreateOperatorInvitationModal'
import OperatorInvitationsList from '@shared/operator_invitations/OperatorInvitationsList'
import OperatorsList from '@shared/operators/OperatorsList'

import { operatorInvitationService } from '@services/operator/operatorInvitationService'
import { operatorService } from '@services/operator/operatorService'
import { warehouseService } from '@services/operator/warehouseService'

const TAB_KEYS = {
  OPERATORS: 'operators',
  INVITATIONS: 'invitations',
}

export default function OperatorOperatorsList() {
  const { t } = useTranslation()
  const can = useCan();
  const [activeTab, setActiveTab] = useState(TAB_KEYS.OPERATORS)
  const [isCreateInvitationModalVisible, setIsCreateInvitationModalVisible] = useState(false)
  const [invitationsRefreshKey, setInvitationsRefreshKey] = useState(0)

  const canCreate = can('operators:write')

  const items = [
    {
      key: TAB_KEYS.OPERATORS,
      label: (
        <span>
          <TeamOutlined />
          {' '}{t('common.resources.operators')}
        </span>
      ),
      children: (
        <OperatorsList
          service={operatorService}
          role="operator"
        />
      ),
    },
    {
      key: TAB_KEYS.INVITATIONS,
      label: (
        <span>
          <MailOutlined />
          {' '}{t('operator.pages.operators.list.tabs.pending_invitations')}
        </span>
      ),
      children: (
        <OperatorInvitationsList
          operatorInvitationService={operatorInvitationService}
          showCard={false}
          refreshKey={invitationsRefreshKey}
        />
      ),
    },
  ]

  return (
    <div>
      <ListPageHeader
        items={['org_management', 'org_management.operators']}
        actions={
          canCreate && (
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setIsCreateInvitationModalVisible(true)}
            >
              {t('common.button.new')}
            </Button>
          )
        }
      />
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
      />
      <CreateOperatorInvitationModal
        open={isCreateInvitationModalVisible}
        onClose={() => setIsCreateInvitationModalVisible(false)}
        onSuccess={() => {
          setActiveTab(TAB_KEYS.INVITATIONS)
          setInvitationsRefreshKey((k) => k + 1)
        }}
        operatorInvitationService={operatorInvitationService}
        warehouseService={warehouseService}
      />
    </div>
  )
}
